import './CreatorCell.scss';
import { useState } from 'react';
import { Badge } from '@Components/Badge';
import { Design, Size } from '@Components/designConstants';

interface CreatorCellProps {
  displayName: string;
  handle: string;
  channelUrl: string;
  thumbnailUrl: string;
  isLocal?: boolean;
}

// A creator's thumbnail, name (linking out to the channel) and handle.
export const CreatorCell = ({
  displayName,
  handle,
  channelUrl,
  thumbnailUrl,
  isLocal = false
}: CreatorCellProps) => (
  <div className='creator-cell'>
    <CreatorThumbnail key={thumbnailUrl} displayName={displayName} thumbnailUrl={thumbnailUrl} />
    <div className='creator-cell-text'>
      <div className='creator-cell-name-row'>
        <a
          className='creator-cell-name'
          href={channelUrl}
          target='_blank'
          rel='noopener noreferrer'
          title={displayName}
        >
          {displayName}
        </a>
        {isLocal && (
          <Badge size={Size.SM} design={Design.NEUTRAL}>
            Local
          </Badge>
        )}
      </div>
      {handle && <div className='creator-cell-handle'>{handle}</div>}
    </div>
  </div>
);

interface CreatorThumbnailProps {
  displayName: string;
  thumbnailUrl: string;
}

// Falls back to the name's first letter when there's no thumbnail or it fails to load. Keyed by
// the URL, so a new image gets a fresh try.
const CreatorThumbnail = ({ displayName, thumbnailUrl }: CreatorThumbnailProps) => {
  const [failed, setFailed] = useState(false);

  if (!thumbnailUrl || failed) {
    return (
      <div className='creator-thumbnail creator-thumbnail-fallback' aria-hidden>
        {displayName.trim().charAt(0).toUpperCase()}
      </div>
    );
  }
  return (
    <img
      className='creator-thumbnail'
      src={thumbnailUrl}
      alt={`${displayName} channel thumbnail`}
      loading='lazy'
      onError={() => setFailed(true)}
    />
  );
};
